
const locationCityOptionsForIndex = [
    {
        id: 1,
        text: "Adana"
    },
    {
        id: 2,
        text: "Adıyaman"
    },
    {
        id: 3,
        text: "Afyonkarahisar"
    },
    {
        id: 4,
        text: "Ağrı"
    },
    {
        id: 68,
        text: "Aksaray"
    },
    {
        id: 5,
        text: "Amasya"
    },
    {
        id: 6,
        text: "Ankara"
    },
    {
        id: 7,
        text: "Antalya"
    },
    {
        id: 75,
        text: "Ardahan"
    },
    {
        id: 8,
        text: "Artvin"
    },
    {
        id: 9,
        text: "Aydın"
    },
    {
        id: 10,
        text: "Balıkesir"
    },
    {
        id: 74,
        text: "Bartın"
    },
    {
        id: 72,
        text: "Batman"
    },
    {
        id: 69,
        text: "Bayburt"
    },
    {
        id: 11,
        text: "Bilecik"
    },
    {
        id: 12,
        text: "Bingöl"
    },
    {
        id: 13,
        text: "Bitlis"
    },
    {
        id: 14,
        text: "Bolu"
    },
    {
        id: 15,
        text: "Burdur"
    },
    {
        id: 16,
        text: "Bursa"
    },
    {
        id: 17,
        text: "Çanakkale"
    },
    {
        id: 18,
        text: "Çankırı"
    },
    {
        id: 19,
        text: "Çorum"
    },
    {
        id: 20,
        text: "Denizli"
    },
    {
        id: 21,
        text: "Diyarbakır"
    },
    {
        id: 81,
        text: "Düzce"
    },
    {
        id: 22,
        text: "Edirne"
    },
    {
        id: 23,
        text: "Elazığ"
    },
    {
        id: 24,
        text: "Erzincan"
    },
    {
        id: 25,
        text: "Erzurum"
    },
    {
        id: 26,
        text: "Eskişehir"
    },
    {
        id: 27,
        text: "Gaziantep"
    },
    {
        id: 28,
        text: "Giresun"
    },
    {
        id: 29,
        text: "Gümüşhane"
    },
    {
        id: 30,
        text: "Hakkari"
    },
    {
        id: 31,
        text: "Hatay"
    },
    {
        id: 76,
        text: "Iğdır"
    },
    {
        id: 32,
        text: "Isparta"
    },
    {
        id: 341,
        text: "İstanbul(Anadolu)"
    },
    {
        id: 342,
        text: "İstanbul(Avrupa)"
    },
    {
        id: 35,
        text: "İzmir"
    },
    {
        id: 46,
        text: "Kahramanmaraş"
    },
    {
        id: 78,
        text: "Karabük"
    },
    {
        id: 70,
        text: "Karaman"
    },
    {
        id: 36,
        text: "Kars"
    },
    {
        id: 37,
        text: "Kastamonu"
    },
    {
        id: 38,
        text: "Kayseri"
    },
    {
        id: 71,
        text: "Kırıkkale"
    },
    {
        id: 39,
        text: "Kırklareli"
    },
    {
        id: 40,
        text: "Kırşehir"
    },
    {
        id: 79,
        text: "Kilis"
    },
    {
        id: 41,
        text: "Kocaeli"
    },
    {
        id: 42,
        text: "Konya"
    },
    {
        id: 43,
        text: "Kütahya"
    },
    {
        id: 44,
        text: "Malatya"
    },
    {
        id: 45,
        text: "Manisa"
    },
    {
        id: 47,
        text: "Mardin"
    },
    {
        id: 33,
        text: "Mersin"
    },
    {
        id: 48,
        text: "Muğla"
    },
    {
        id: 49,
        text: "Muş"
    },
    {
        id: 50,
        text: "Nevşehir"
    },
    {
        id: 51,
        text: "Niğde"
    },
    {
        id: 52,
        text: "Ordu"
    },
    {
        id: 80,
        text: "Osmaniye"
    },
    {
        id: 53,
        text: "Rize"
    },
    {
        id: 54,
        text: "Sakarya"
    },
    {
        id: 55,
        text: "Samsun"
    },
    {
        id: 56,
        text: "Siirt"
    },
    {
        id: 57,
        text: "Sinop"
    },
    {
        id: 58,
        text: "Sivas"
    },
    {
        id: 63,
        text: "Şanlıurfa"
    },
    {
        id: 73,
        text: "Şırnak"
    },
    {
        id: 59,
        text: "Tekirdağ"
    },
    {
        id: 60,
        text: "Tokat"
    },
    {
        id: 61,
        text: "Trabzon"
    },
    {
        id: 62,
        text: "Tunceli"
    },
    {
        id: 64,
        text: "Uşak"
    },
    {
        id: 65,
        text: "Van"
    },
    {
        id: 77,
        text: "Yalova"
    },
    {
        id: 66,
        text: "Yozgat"
    },
    {
        id: 67,
        text: "Zonguldak"
    }
]

export default locationCityOptionsForIndex